import {DetailedProps, join} from '@esgillc/ui-kit/utils';
import {forwardRef} from 'react';
import styles from './styles.module.less';

export const Text = forwardRef<HTMLSpanElement, DetailedProps<HTMLSpanElement>>((props, ref) => <span {...props} ref={ref} className={join(styles.text, props.className)}/>);
